import { SaFStyleType } from '~/components/Charts/SaF/SaF.types'

const saf: SaFStyleType = {
  pillTipHeight: 14,
  pillWidth: 28,
  pillsGap: 8,
  pillMininumBoxHeight: 36,
  chartColumnMinimumWidth: 405,
  chartHeightPerNode: 200,

  nodeColors: [
    [
      { background: '#B97955', stockBackground: '#98A352', text: '#FFFFFF' },
      { background: '#5C3C2A', stockBackground: '#4C5229', text: '#FFFFFF' }
    ],
    [
      { background: '#BA6262', stockBackground: '#5F926E', text: '#FFFFFF' },
      { background: '#5D3131', stockBackground: '#304937', text: '#FFFFFF' }
    ],
    [
      { background: '#9E334D', stockBackground: '#338B9E', text: '#FFFFFF' },
      { background: '#4F1A26', stockBackground: '#1A464F', text: '#FFFFFF' }
    ],
    [
      { background: '#B862BA', stockBackground: '#2A67BC', text: '#FFFFFF' },
      { background: '#5C315D', stockBackground: '#15345E', text: '#FFFFFF' }
    ],
    [
      { background: '#6F339E', stockBackground: '#33529E', text: '#FFFFFF' },
      { background: '#381A4F', stockBackground: '#1A294F', text: '#FFFFFF' }
    ],
    [
      { background: '#7A4EC2', stockBackground: '#4D6194', text: '#FFFFFF' },
      { background: '#3D2761', stockBackground: '#26304A', text: '#FFFFFF' }
    ],
    [
      { background: '#4D6194', stockBackground: '#B97955', text: '#FFFFFF' },
      { background: '#26304A', stockBackground: '#5C3C2A', text: '#FFFFFF' }
    ],
    [
      { background: '#33529E', stockBackground: '#BA6262', text: '#FFFFFF' },
      { background: '#1A294F', stockBackground: '#5D3131', text: '#FFFFFF' }
    ],
    [
      { background: '#2A67BC', stockBackground: '#9E334D', text: '#FFFFFF' },
      { background: '#15345E', stockBackground: '#4F1A26', text: '#FFFFFF' }
    ],
    [
      { background: '#338B9E', stockBackground: '#B862BA', text: '#FFFFFF' },
      { background: '#1A464F', stockBackground: '#5C315D', text: '#FFFFFF' }
    ],
    [
      { background: '#5F926E', stockBackground: '#6F339E', text: '#FFFFFF' },
      { background: '#304937', stockBackground: '#381A4F', text: '#FFFFFF' }
    ],
    [
      { background: '#98A352', stockBackground: '#7A4EC2', text: '#000000' },
      { background: '#4C5229', stockBackground: '#3D2761', text: '#FFFFFF' }
    ]
  ]
}

export default saf
